<mat-progress-bar *ngIf="loading.process.pending$ | async" mode="query">
  <mat-progress-bar></mat-progress-bar>
</mat-progress-bar>
